<template>
  <router-view></router-view>
</template>
<script>
export default {
  
}
</script>
<style lang="less">
.tooltipCustom{
  .textWrap{
    line-height: 17px;
    .clickText{
      cursor: pointer;
      color: @currentColor;
    }
  }
}
</style>